import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import { Topbar, Spinner } from './components';
import LoginPage      from './LoginPage';
import OverviewPage   from './OverviewPage';
import HostDetailPage from './HostDetailPage';
import AdminPage      from './AdminPage';

function PrivateRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <Spinner />;
  if (!user)  return <Navigate to="/login" replace />;
  return children;
}

function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Topbar user={user} onLogout={handleLogout}
              onAdmin={() => navigate('/admin')} />
      <div style={{ flex: 1 }}>{children}</div>
      <footer style={{
        borderTop: '1px solid var(--border)',
        padding: '10px 24px',
        fontFamily: 'var(--mono)',
        fontSize: 10,
        color: 'var(--muted)',
        display: 'flex',
        justifyContent: 'space-between',
      }}>
        <span>SYSMON</span>
        <span>AUTO-REFRESH 10s</span>
      </footer>
    </div>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={
        <PrivateRoute>
          <Layout><OverviewPage userRole="viewer" /></Layout>
        </PrivateRoute>
      } />
      <Route path="/host/:id" element={
        <PrivateRoute>
          <Layout><HostDetailPage /></Layout>
        </PrivateRoute>
      } />
      <Route path="/admin" element={
        <PrivateRoute>
          <Layout><AdminPage /></Layout>
        </PrivateRoute>
      } />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

// Pass user down to OverviewPage properly
function OverviewWithUser() {
  const { user } = useAuth();
  return <OverviewPage user={user} />;
}

function AppRoutesFixed() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={
        <PrivateRoute>
          <Layout><OverviewWithUser /></Layout>
        </PrivateRoute>
      } />
      <Route path="/host/:id" element={
        <PrivateRoute>
          <Layout><HostDetailPage /></Layout>
        </PrivateRoute>
      } />
      <Route path="/admin" element={
        <PrivateRoute>
          <Layout><AdminPage /></Layout>
        </PrivateRoute>
      } />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutesFixed />
      </BrowserRouter>
    </AuthProvider>
  );
}
